import {type RedirectFunction, type RouterState} from 'react-router';

import {getFeatureFlagStatus} from 'client/components/FeatureFlag/featureFlag.utils';
import sessionStore from 'client/Session/SessionStore';

export default function checkFeatureFlagStatusOnEnter(
  flag: string,
  fallbackRoute: string,
  behavior: 'disallow' | 'require',
  skipAuth = false
) {
  return async (
    _nextState: RouterState,
    replace: RedirectFunction,
    callback?: (...args: any[]) => any
  ) => {
    if (!skipAuth && !sessionStore.hasValidSession()) {
      replace('/log-in');
      callback?.();
      return;
    }

    const isFlagEnabled = await getFeatureFlagStatus(flag);
    if ((behavior === 'disallow' && isFlagEnabled) || (behavior === 'require' && !isFlagEnabled)) {
      replace(fallbackRoute);
    }

    callback?.();
  };
}
